import React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton, Typography, Grid, Box, Button, useTheme, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import PageLang from "../../../config/page.languge";
import useResponsive from "../../../hooks/useResponsive";
import { NAVIGATE_AUTH } from "../../../constant";
import { resetProjectLocation } from "../../../redux/reducer/locationSlice";
import ImageWithLoader from "../../common/ImageWithLoader";

interface RegisterDialogProps {
    open: boolean;
    onClose: () => void;
}

const RegisterDialog: React.FC<RegisterDialogProps> = ({ open, onClose }) => {
    const theme = useTheme();
    const language = useSelector((state: RootState) => state.language.language);
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const { isMobile } = useResponsive()

    const handleDialog = (url: string) => {
        onClose();
        dispatch(resetProjectLocation())
        navigate(url);
    };


    const handleNavigate = () => {
        onClose();
        navigate(NAVIGATE_AUTH.LOGIN_PAGE)
    }
    const circleStyle = {
        width: 150,
        height: 150,
        borderRadius: "50%",
        backgroundColor: theme.palette.primary.light,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        border: `2px solid ${theme.palette.primary.main}`,
        cursor: "pointer",
        color: "#CE2B19",

        "&:hover": {
            border: `2px solid ${theme.palette.warning.light}`,
            boxShadow: `1px 1px 5px 1px ${theme.palette.warning.light}`,
            color: "green"
        },

    };
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ textAlign: "center", position: "relative" }}>
                <Box sx={{ textAlign: "center", mt: 2, mb: 3 }} display={'flex'} justifyContent="center" alignItems="center" flexDirection="column">
                    <Typography variant="h2" fontWeight="bold" color="primary">
                        {PageLang?.RegisterDialog?.Title[language]}
                    </Typography>
                    <Divider sx={{ height: 4, width: 120, mt: 1, borderRadius: 2, background: `linear-gradient(to right, ${theme.palette.warning.dark}, ${theme.palette.warning.light})`, }} />
                </Box>
                <IconButton onClick={onClose} sx={{ position: "absolute", right: 10, top: 10 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Grid container spacing={isMobile ? 1 : 0} justifyContent="center">
                    {PageLang?.RegisterDialog?.DialogOptions.map(({ key, url, icon, ...labels }) => (
                        <Grid item xs={isMobile ? 6 : 3} key={key} sx={{ mr:3}}>
                            <Box sx={{ ...circleStyle, m: 2, background: "white" }} onClick={() => handleDialog(url)}>
                                <Box mb={2}>
                                    <ImageWithLoader
                                        src={icon}
                                        alt="Hospital"
                                        style={{ width: "100%", maxHeight: 50, objectFit: "contain" }}
                                    />
                                </Box>
                                <Typography sx={{ width: 100, fontWeight: 600, color: theme.palette.primary.main }}>{labels[language]}</Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>
            <Box sx={{ textAlign: "center", mb: 3 }} display={'flex'} justifyContent="center">
                <Button variant="text" color="primary" sx={{ fontWeight: 550 }} onClick={() => handleNavigate()}>
                    {PageLang?.RegisterDialog?.DialogFooter[language]}
                </Button>
            </Box>
        </Dialog >
    );
};

export default RegisterDialog;
